// extracted by mini-css-extract-plugin
module.exports = {"keywordGroup":"KeywordSearchGroupForJobs_keywordGroup__1wzfE","container":"KeywordSearchGroupForJobs_container__2UPto","sending":"KeywordSearchGroupForJobs_sending__39D9a"};